/**
 * Valida se um tipo de usuário pode acessar uma rota do sistema
 * Usa como base o arquivo ROTAS_SISTEMA_SGQ
 */

import { ROTAS_SISTEMA_SGQ } from "../app/routesSistema";

// ⚠️ Ajuste o caminho acima SOMENTE se seu routesSistema estiver em outro lugar
// Ex: "../app/routesSistema"

function rotaCorresponde(pathname, rotaBase) {
  // rota exata
  if (pathname === rotaBase) return true;

  const partes = pathname.split("/");
  const modelo = rotaBase.split("/");
  if (partes.length === modelo.length && modelo.every((parte, indice) =>
    parte.startsWith(":") ? Boolean(partes[indice]) : parte === partes[indice]
  )) return true;

  // rota dinâmica (ex: /kpi/evento/:id)
  if (pathname.startsWith(rotaBase + "/")) return true;

  return false;
}

export function temPermissaoRota(pathname, tipoUsuario) {
  // segurança básica
  if (!pathname || !tipoUsuario) return false;

  // admin sempre pode
  if (tipoUsuario === "admin") return true;

  // procura a rota cadastrada
  const rota = ROTAS_SISTEMA_SGQ.find(r => r.path === pathname) ||
    [...ROTAS_SISTEMA_SGQ].sort((a, b) => b.path.length - a.path.length).find(r =>
    rotaCorresponde(pathname, r.path)
  );

  // rota não registrada → nega por padrão
  if (!rota) return false;

  // valida se o tipo está autorizado
  return Array.isArray(rota.tipos) && rota.tipos.includes(tipoUsuario);
}
